import { ref } from 'vue'

interface Toast {
  id: string
  title: string
  message?: string
  type: 'success' | 'error' | 'info'
  duration?: number
}

const toasts = ref<Toast[]>([])

export function useToast() {
  const showToast = (toast: Omit<Toast, 'id'>) => {
    const id = Math.random().toString(36).substr(2, 9)
    const newToast: Toast = {
      id,
      ...toast
    }
    
    toasts.value.push(newToast)
    
    return id
  }
  
  const removeToast = (id: string) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }
  
  const showSuccess = (title: string, message?: string, duration?: number) => {
    return showToast({
      title,
      message,
      type: 'success',
      duration: duration ?? 3000
    })
  }
  
  const showError = (title: string, message?: string, duration?: number) => {
    return showToast({
      title,
      message,
      type: 'error',
      duration: duration ?? 5000
    })
  }
  
  const showInfo = (title: string, message?: string, duration?: number) => {
    return showToast({
      title,
      message,
      type: 'info',
      duration: duration ?? 3000
    })
  }
  
  return {
    toasts,
    showToast,
    removeToast,
    showSuccess,
    showError,
    showInfo
  }
} 